import React from "react";
import "./Programs_Offered_card.css";

function Programs_Offered_card({
  reverse,
  title,
  image,
  listBlocks = [],
}) {
  return (
    <>
      <div className={`Programs_Offered_card ${reverse ? "reverse_row" : ""}`}>
        <div className="container">

          {/* TITLE */}
          <div className="main_heading_holder">
            <h6>{title}</h6>
          </div>

          <div className="row">
            
            {/* IMAGE */}
            <div className="col-md-5">
              <div className="img_holder">
                <img src={image} alt="" className="program_img" />
              </div>
            </div>

            {/* CONTENT */}
            <div className="col-md-7">
              <div className="content_holder">

                {listBlocks.map((block, index) => (
                  <div className="list_contant_holder" key={index}>
                    <div className="list_heading_holder">

                      {/* BLOCK HEADING */}
                      <h2>{block.heading}</h2>

                      {/* LIST ITEMS */}
                      <div className="list_holder">
                        <ul>
                          {block.points.map((point, pIndex) => (
                            <li key={pIndex}>{point}</li>
                          ))}
                        </ul>
                      </div>

                    </div>
                  </div>
                ))}

              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default Programs_Offered_card;
